import React from 'react'
import ResetPassword from '../components/ResetPassword'

const ResetPasswordPage = () => <ResetPassword />

export default ResetPasswordPage
